import authFetch from './fetch';
import { makeRequest, getQueryParams } from './utils';

export const routes = {

  predefinedFilterPath: (entityName, filterId) => `api/filtering/${entityName}/byFilter/${filterId}`,
  filteringPath: (entityName, paginated, params) => `api/filtering/${entityName}/${paginated ? 'paginated' : ''}${getQueryParams(params)}`
};

export const filterByPredefinedFilter = (entityName, filterId) => makeRequest(authFetch.get(routes.predefinedFilterPath(entityName, filterId)))
export const getFilteredData = (entityName, filter, paginated, params) => makeRequest(authFetch.post(routes.filteringPath(entityName, paginated, params), { filter }))